import { render, staticRenderFns } from "./ChartRadialBarRate.vue?vue&type=template&id=38c00de0&scoped=true&"
import script from "./ChartRadialBarRate.vue?vue&type=script&lang=js&"
export * from "./ChartRadialBarRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c00de0",
  null
  
)

export default component.exports